<template>
  <el-dialog
    class="fc-dialog"
    title="配送物流人员"
    v-if="showDialog"
    :visible.sync="showDialog"
    width="520px"
    :before-close="handleClose"

  >
    <el-form
      ref="form"
      :model="form"
      class="form-box"
      label-position="right"
      label-width="120px"
      size="small"
      :rules="rules"
    >
      <el-form-item label="物流人员" prop="driverId" required>
        <el-select v-model="form.driverId" placeholder="全部" filterable @change="driverListChange">
          <el-option v-for="item of driverList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发车时间" prop="departureTime" >
        <el-date-picker v-model="form.departureTime" type="datetime" />
      </el-form-item>

      <el-form-item label="车牌号" prop="arlicense" >
        <el-input v-model="form.arlicense" placeholder="请输入车牌号" clearable />
      </el-form-item>
    </el-form>
    <div class="queryBtn">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button type="primary" size="small" @click="confirmData" v-if="type==1">确认</el-button>
      <el-button type="primary" size="small" @click="update" v-if="type==2">确认</el-button>
      <el-button type="primary" size="small" @click="updatepreDriver" v-if="type==3">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { freightDriverList, warehouseQuickStart, updateDriver,updatePreDriver } from "@/api/logistics";
import moment from "moment";
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    addressShopList: {
      type: Array
    }
  },
  data() {
    return {
      form: {
        driverId: "",
        departureTime: "",
        arlicense: "",
        companyId:''
      },
      driverList: [],
      rules: {
        driverId: {
          required: true,
          message: "物流人员不允许为空",
          trigger: "blur"
        },
      },
      type:'1',  //1.快速分配分配司机 2.修改物流人员信息 3.预分配修改物流人员
      recheckId:"",//type=2确认id
      orderOutboundCollectIds:[],//type=2修改数据
      orderIds:[],//type=3修改数据
    };
  },
  created() {
    this.initPage();
  },
  methods: {
    moment,
    // 初始化物流人员
    initPage() {
      // 物流人员列表
      freightDriverList().then(res => {
        if (res.code == 0) {
          this.driverList = res.data;
        }
      });
    },
    // 选择物流人员
    driverListChange(val) {
      this.driverList.forEach(item=>{
          if(item.id == val){
              this.form.companyId = item.companyId
          }
      })
    },
    // 确认发车
    confirmData() {

      this.$refs["form"].validate(valid => {
        if (valid) {
          let data = {
            addressShopList: this.addressShopList,
            freightDriverId: this.form.driverId,
            companyId:this.form.companyId,
            arlicense: this.form.arlicense?this.form.arlicense:'',
            departureTime: this.form.departureTime?this.moment(this.form.departureTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ):''
          };
          warehouseQuickStart(this.filterEmpyKey(data)).then(res=>{
            if(res.code == 0){
              this.$message({
                type: "success",
                message: "操作成功"
              });
              Object.keys(this.form).forEach(key =>{
                this.form[key] ='';
              })
              this.$emit("closeDialog");
            }
          })
        } else {
          return false;
        }
      });
    },
    // 关闭
    handleClose() {
      this.$emit("closeDialog");
      Object.keys(this.form).forEach(key =>{
        this.form[key] ='';
      })
    },
    show(type,data,recheckId){
       if(data.length==0){
        this.$message.error('请选择需要修改司机的数据');
        return;
       }
        this.type = type;
        this.recheckId = recheckId;
        this.showDialog = true;
        this.orderOutboundCollectIds = data;
    },
    update(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          let data = {
            recheckId: this.recheckId,
            orderOutboundCollectIds: this.orderOutboundCollectIds,
            driverId: this.form.driverId,
            companyId:this.form.companyId,
            arlicense: this.form.arlicense?this.form.arlicense:'',
            departureTime: this.form.departureTime?this.moment(this.form.departureTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ):''
          };
          updateDriver(this.filterEmpyKey(data)).then(res=>{
            if(res.code == 0){
              this.$message({
                type: "success",
                message: "修改分配司机成功"
              });
              Object.keys(this.form).forEach(key =>{
                this.form[key] ='';
              })
              this.$emit("closeDialog");
            }

          })
        } else {
          return false;
        }
      });
    },
    //修改预分配司机
    updatepreDriver(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          let data = {
            orderIds: this.orderOutboundCollectIds,
            driverId: this.form.driverId,
            companyId:this.form.companyId,
            arlicense: this.form.arlicense?this.form.arlicense:'',
            departureTime: this.form.departureTime?this.moment(this.form.departureTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ):''
          };
          updatePreDriver(this.filterEmpyKey(data)).then(res=>{
            if(res.code == 0){
              this.$message({
                type: "success",
                message: "修改分配司机成功"
              });
              Object.keys(this.form).forEach(key =>{
                this.form[key] ='';
              })
              this.$emit("closeDialog");
            }

          })
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.queryBtn {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-box {
  padding: 20px 0 10px 0;
}
.fc-dialog /deep/ .el-input {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/logisticsDelivery/modules/distributionQuickDialog.vue